export default __webpack_public_path__ + "static/media/check.636642d7.svg";